function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
import React, { forwardRef, useImperativeHandle, useMemo, useState } from 'react';
import { EnhanceComponent } from "../../middleware/EnhanceComponent";
import setting from "./setting";
import { getPrefixCls } from "../../utils/common";
import "./style.less";
import { Button, Popup, ProductChoose } from "../../common";
import commonPool from "../../store/commonPool";
var prefixCls = getPrefixCls('SmMultiProductsModal');
var MultiProducts = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$schema, _props$schema$params, _props$params, _props$schema2, _props$schema2$params, _Object$keys;
  var _ref = props.productInfo || (props === null || props === void 0 ? void 0 : (_props$schema = props.schema) === null || _props$schema === void 0 ? void 0 : (_props$schema$params = _props$schema.params) === null || _props$schema$params === void 0 ? void 0 : _props$schema$params.productInfo) || {},
    primaryProduct = _ref.product,
    activityDetail = _ref.activity,
    products = _ref.products,
    hasBuy = _ref.hasBuy,
    orderProduct = _ref.orderProduct,
    disabled = _ref.hasDisabled,
    productType = _ref.productType,
    isTrial = _ref.isTrial,
    skipPayment = _ref.skipPayment;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    selectedProductStatus = _useState2[0],
    setSelectedProductStatus = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    visible = _useState4[0],
    setVisible = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    element = _useState6[0],
    setElement = _useState6[1];
  var source = ((_props$params = props.params) === null || _props$params === void 0 ? void 0 : _props$params.source) || ((_props$schema2 = props.schema) === null || _props$schema2 === void 0 ? void 0 : (_props$schema2$params = _props$schema2.params) === null || _props$schema2$params === void 0 ? void 0 : _props$schema2$params.source);
  var isDev = source === 'development' || (props === null || props === void 0 ? void 0 : props.componentRenderStatus) === 'preview';
  var isEdit = source === 'development';
  var product = useMemo(function () {
    return primaryProduct || (products && (activityDetail.channelDeliveryGroupId || products.length === 1) ? products[0] : null) || (isTrial ? products[0] : null) || commonPool.getSelectedProduct();
  }, [primaryProduct, products, activityDetail, isTrial, commonPool.getSelectedProduct(), selectedProductStatus]);
  var openModal = function openModal() {
    return setVisible(true);
  };
  var chooseElement = function chooseElement(tag) {
    setElement(tag || '');
  };
  useImperativeHandle(ref, function () {
    return {
      openModal: openModal,
      chooseElement: chooseElement
    };
  });
  var handleChangeProduct = function handleChangeProduct(product) {
    commonPool.setSelectedProduct(product);
    var refs = commonPool.getRefs();
    for (var key in refs) {
      if (Object.prototype.hasOwnProperty.call(refs, key)) {
        var _refs$key, _refs$key$ref, _refs$key$ref$current, _refs$key$ref$current2, _refs$key$ref$current3;
        (_refs$key = refs[key]) === null || _refs$key === void 0 ? void 0 : (_refs$key$ref = _refs$key.ref) === null || _refs$key$ref === void 0 ? void 0 : (_refs$key$ref$current = _refs$key$ref.current) === null || _refs$key$ref$current === void 0 ? void 0 : (_refs$key$ref$current2 = (_refs$key$ref$current3 = _refs$key$ref$current).updateSelectProduct) === null || _refs$key$ref$current2 === void 0 ? void 0 : _refs$key$ref$current2.call(_refs$key$ref$current3);
      }
    }
    setSelectedProductStatus({});
  };
  var immediatelyApply = function immediatelyApply() {
    var refs = commonPool.getRefs();
    for (var key in refs) {
      if (Object.prototype.hasOwnProperty.call(refs, key)) {
        if (key === element) {
          var _refs$key2, _refs$key2$ref, _refs$key2$ref$curren, _refs$key2$ref$curren2, _refs$key2$ref$curren3;
          (_refs$key2 = refs[key]) === null || _refs$key2 === void 0 ? void 0 : (_refs$key2$ref = _refs$key2.ref) === null || _refs$key2$ref === void 0 ? void 0 : (_refs$key2$ref$curren = _refs$key2$ref.current) === null || _refs$key2$ref$curren === void 0 ? void 0 : (_refs$key2$ref$curren2 = (_refs$key2$ref$curren3 = _refs$key2$ref$curren).modalClose) === null || _refs$key2$ref$curren2 === void 0 ? void 0 : _refs$key2$ref$curren2.call(_refs$key2$ref$curren3, 'multiProductsModal', 'success');
        }
      }
    }
    setVisible(false);
    setElement('');
  };
  var onClose = function onClose() {
    var _refs$element, _refs$element$ref, _refs$element$ref$cur, _refs$element$ref$cur2;
    var refs = commonPool.getRefs();
    (_refs$element = refs[element]) === null || _refs$element === void 0 ? void 0 : (_refs$element$ref = _refs$element.ref) === null || _refs$element$ref === void 0 ? void 0 : (_refs$element$ref$cur = _refs$element$ref.current) === null || _refs$element$ref$cur === void 0 ? void 0 : (_refs$element$ref$cur2 = _refs$element$ref$cur.modalClose) === null || _refs$element$ref$cur2 === void 0 ? void 0 : _refs$element$ref$cur2.call(_refs$element$ref$cur, 'multiProductsModal', 'settled');
    setVisible(false);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, isEdit && /*#__PURE__*/React.createElement("div", null, "\u591A\u5546\u54C1\u7EC4\u4EF6\u5360\u4F4D"), /*#__PURE__*/React.createElement(Popup, {
    onMaskClick: onClose,
    visible: visible,
    getContainer: function getContainer() {
      return document.querySelector('.dnd-container') || document.body;
    }
  }, /*#__PURE__*/React.createElement(ProductChoose, {
    activityDetail: activityDetail,
    value: product,
    productList: products,
    onChoose: handleChangeProduct
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: !((_Object$keys = Object.keys(product)) !== null && _Object$keys !== void 0 && _Object$keys.length),
    color: "primary",
    className: "".concat(prefixCls, "-apply-button"),
    onClick: immediatelyApply
  }, "\u7ACB\u5373\u62A5\u540D"))));
});
var EnhanceMultiProducts = EnhanceComponent(MultiProducts);
EnhanceMultiProducts.settings = setting;
export default EnhanceMultiProducts;